import { useSelector } from "react-redux";
import { dataHookFactory } from "../common/reducers/utilities";
import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ensureArray } from "../common/utils/arrayUtilities";
import { logout } from "../common/reducers/initContext";

const settingSlice = createSlice({
    name: 'settings',
    initialState: {
        defs: {},
        loading: true,
    },
    reducers: {
        setLoading: (state, action) => {
            state.loading = !!action.payload
        },
        set: (state, action) => {
            state.defs = action.payload
        },
        addOrUpdate: (state, action) => {
            for (const s of ensureArray(action.payload)) {
                state.defs[s.key] = s;
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => settingSlice.getInitialState());
    }
});

// #region network operations
const fetchSettings = async network => {
    network.dispatch(settingSlice.actions.setLoading(true));
    let result = false;
    try {
        result = await network.get('/api/v1/settings', settingSlice.actions.set);
    } finally {
        network.dispatch(settingSlice.actions.setLoading(false));
    }
    return result;
}
export const upsertSetting = (network, username, key, value) => {
    return network.post('/api/v1/setting', { username, key , value }, settingSlice.actions.addOrUpdate);
}
// #endregion

// #region selectors
const selectSettingMap = state => state.settings.defs;
const selectSetting = key => createSelector([selectSettingMap], (settings) => settings?.[key]);
const selectLoading = state => state.settings.loading;
// #endregion

const listen = {
    settingUpserted: (setting, { dispatch }) => dispatch(settingSlice.actions.addOrUpdate(setting))
}

export const [useSetting] = dataHookFactory(selectSetting, { run: fetchSettings, listen, immortal: true });
export const useSettingsLoading = () => useSelector(selectLoading);

const reducerDetails = { name: settingSlice.name, reducer: settingSlice.reducer };
export default reducerDetails;